<template>
  <div>
    <el-steps :active="active" finish-status="success" :process-status="processStatus" align-center>
      <el-step v-for="stepInfo in stepDesc" :key="stepInfo.title"
               :title="stepInfo.title"
               :description="stepInfo.desc"
               process-status="process"
      />
    </el-steps>
    <el-dialog title="选择您需要测试的打印机" :visible.sync="selectPrinter" width="20%">
      <el-select v-model="selectedPrinter" placeholder="请选择">
        <el-option
            v-for="item in printers"
            :key="item.name"
            :label="item.name"
            :value="item.name">
        </el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="selectPrinter = false">取 消</el-button>
        <el-button type="primary" @click="printHandle(true)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import axios from "axios";
import $ from 'jquery';
import {Loading} from 'element-ui';
import CheckMain from "@/checkMain";
// import SyncWebsocket from 'sync-websocket'

export default {
  name: "AutoCheck",
  mounted() {
    this.startCheck()
  },
  methods: {
    sleep(delay) {
      var start = new Date().getTime();
      while (new Date().getTime() < start + delay * 1000) ;
    },
    startCheck() {
      this.active = -1
      this.handle({state: true, resp: undefined})
    },


    tryOpenPlugin() {
      if (this.tryOpenApp) {
        this.tryOpenApp = false
        this.updateDesc("正在尝试唤醒组件")
        this.$alert('将尝试为您启动组件,请在弹出的对话框中点击同意', '启动组件', {
          confirmButtonText: '确定',
          callback: () => {
            this.loading("正在为您启动组件")
            window.open("CNPRINT://open")
            let recall = () => {
              this.cancelLoading()
              this.checkAppOpen()
            }
            window.setTimeout(recall, 5 * 1000);
          }
        });
      } else {
        let desc2 = "未安装组件或者组件版本较低,请手动启动,若已启动但无法识别则需要关闭 360 等软件重新安装"
        this.$confirm(desc2, '请手动启动组件', {
          confirmButtonText: '打开下载页',
          cancelButtonText: '我知道了',
          callback: () => {
            window.open("https://page.cainiao.com/waybill/cloud_printing/home.html")
          }
        });

        this.handle({
          state: false,
          desc: desc2
        })
      }
    },
    /**
     *  检查客户端是否启动
     * @returns {boolean}
     */
    async checkAppOpen() {
      return this.tryConnected("ws://localhost:13528", true, "组件已成功启动", true)
    },

    tryConnected(address, tryOpen, successDesc, closeIfOpend) {
      let me = this
      this.websocket = new WebSocket(address)
      this.websocket.onopen = () => {
        if (closeIfOpend) {
          me.websocket.close()
          me.websocket = null
        }
        CheckMain.handle({
          state: true,
          desc: successDesc
        })
        console.log("connected")
      }
      this.websocket.onerror = ev => {
        console.log("failed " + ev)
        if (tryOpen) {
          this.tryOpenPlugin()
        } else {
          this.$confirm('请重启浏览器或千牛', 'WSS检查', {
            distinguishCancelAndClose: true,
            confirmButtonText: '好',
            cancelButtonText: '已经重启过'
          }).then(() => {
            window.close()
          }).catch(() => {
            this.$alert("即将为您打开证书下载页,请按照页内操作安装证书", '下载证书', {
              confirmButtonText: '好',
              callback: () => {
                this.stepDesc[this.active].desc = "证书安装后请即系重启浏览器或千牛"
                window.open("https://support-cnkuaidi.taobao.com/docs/doc.htm?treeId=493&articleId=107789&docType=1")
              }
            })
          });
        }
        me.websocket = null
      }
    },

    /**
     * 检查 wss 链接
     */
    async checkWss() {
      let me = this
      this.tryConnected("wss://localhost:13529", false, undefined, false)
      this.websocket.onmessage = received => {
        let data = JSON.parse(received.data)
        if (data.cmd) {
          if (data.cmd === "print") {
            data.cmd = "printHandle"
          }
          let method = this[data.cmd]
          console.log("method name " + data.cmd + " " + method)
          if (method instanceof Function) {
            method(false, data)
          } else {
            me.defaultHandle(false, data)
          }
        }
      }
    },
    /**
     * 检查 cdn 网络
     */
    async checkCDN() {
      let url = "//cdn-cloudprint.cainiao.com/waybill-print/cdn-test"
      let me = this
      $.ajax({
        type: 'get',
        cache: false,
        url: url,
        dataType: "jsonp", //跨域采用jsonp方式
        processData: false,
        timeout: 1000, //超时时间，毫秒
        complete: function (data) {
          console.log("data.status" + data.status)
          if (data.status === 200) {
            CheckMain.handle({
              state: true,
              desc: "CDN 网络已验证"
            })
          } else {
            let desc2 = "CDN 网络异常,请参照帮助页进行操作"
            CheckMain.handle({
              state: false,
              desc: desc2
            })
            me.$alert("即将为您跳转到帮助页", desc2, {
              confirmButtonText: '好',
              callback: () => {
                window.open("https://support-cnkuaidi.taobao.com/docs/doc.htm?treeId=493&articleId=107799&docType=1")
              }
            });
          }

        }
      });
    },
    /**
     * 缓存清理
     */
    async clearCache(send, data) {
      let me = this
      if (send) {
        let cmd = {
          "cmd": "clearCache"
        }
        this.websocket.send(JSON.stringify(cmd))
      } else {
        console.log(data)
        me.handle({
          state: true,
          desc: "缓存清理成功"
        })
      }
    },
    /**
     * 预览
     */
    async preview(send, data) {
      let me = this
      if (send) {

        this.previewData.task.taskID = Date.now() + ""
        me.websocket.send(JSON.stringify(this.previewData))
        await this.getPrinters(true, null)
      } else {
        let previewURL = data.previewURL
        if (previewURL) {
          //获取打印机列表,为后续的测试提供数据
          me.$confirm('打开预览文件' + previewURL, '预览文件', {
            distinguishCancelAndClose: true,
            confirmButtonText: '好',
            cancelButtonText: '不用'
          }).then(() => {
            window.open(previewURL)
            me.handle({
              state: true,
              desc: "PDF预览正常,已为您打开预览页面"
            })
          }).catch(() => {
            me.handle({
              state: true,
              desc: "PDF预览正常,静默预览"
            })
          })
        }
      }
    },
    /**
     * 获取打印机列表
     * @param send
     * @param data
     * @returns {Promise<void>}
     */
    async getPrinters(send, data) {
      let me = this
      if (send) {
        let cmd = {
          "cmd": "getPrinters"
        }
        me.websocket.send(JSON.stringify(cmd))
      } else {
        if (data.printers) {
          me.printers = data.printers
          me.selectedPrinter = data.defaultPrinter
        }
      }
    },

    async defaultHandle(send, data) {
      let me = this
      console.log(send)
      let errorCode = data.errorCode
      if (errorCode && errorCode === 0) {
        //正常

      } else {
        let code = data.code
        let detail = data.detail
        if (code) {
          me.$confirm(detail, '错误' + code, {
            distinguishCancelAndClose: true,
            confirmButtonText: '前往知识库',
            cancelButtonText: '不用'
          }).then(() => {
            window.open("https://support-cnkuaidi.taobao.com/docs/doc.htm?treeId=493&articleId=108078&docType=1")
          }).catch(() => {

          })
          me.handle({
            state: false,
            desc: "预览异常,错误信息为" + detail
          })
        }
      }
    },
    /**
     * 进行打印测试
     * @param send
     * @param data
     * @returns {Promise<void>}
     */
    async printHandle(send, data) {
      let me = this
      if (send) {
        this.selectPrinter = false
        console.log("printer" + JSON.stringify(this.printers))
        this.previewData.task.taskID = Date.now() + ""
        this.previewData.task.preview = false
        this.previewData.task.printer = this.selectedPrinter
        me.websocket.send(JSON.stringify(this.previewData))
      } else {
        if (data.previewURL) {
          await this.preview(false, data)
        } else {
          this.loading("打印执行中")
        }

      }
    },
    async notifyPrintResult(send, data) {
      console.log(send)
      this.cancelLoading()
      if (data.taskStatus === "rendered") {
        await this.$confirm("打印已完成", "打印测试", {
          confirmButtonText: '一切正常',
          cancelButtonText: '不正常',
          callback: (action) => {
            if (action === "cancel") {
              this.handle({
                state: false,
                desc: "用户反馈异常"
              })
              window.open("https://support-cnkuaidi.taobao.com/docs/doc.htm?treeId=493&articleId=107778&docType=1")
            } else {
              this.handle({
                state: true,
                desc: "一切正常"
              })
            }
          }
        })
      }
    },
    loading(txt) {
      if (!this.loadingInstance) {
        this.loadingInstance = Loading.service({
          text: txt
        })
      }

    },
    cancelLoading() {
      if (this.loadingInstance) {
        this.loadingInstance.close()
        this.loadingInstance = null
      }
    },
    updateDesc(desc) {
      if (desc) {
        let current = this.stepDesc[this.active]
        current.desc = desc
      }
    },
    /**
     * 状态机处理函数
     */
    handle(resp) {
      let stepDesc = this.stepDesc
      if (this.active > stepDesc.length) {
        return
      }
      let current = stepDesc[this.active]
      this.updateDesc(resp.desc)
      if (resp.state) {
        this.active++
        if (this.active < stepDesc.length) {
          current = stepDesc[this.active]
          current
              .handle()
              .then(resp => {
                if (resp && resp.sync) {
                  this.handle(resp)
                }
              })
        }
      } else {
        this.processStatus = "error"
      }
    }
  },
  created() {
    this.stepDesc = [
      {
        title: "系统环境检查",
        desc: "",
        handle: () => CheckMain.checkSys()
      },
      {
        title: "打印组件运行态检查",
        desc: "检查打印组件是否启动",
        handle: () => this.checkAppOpen()
      },
      // {
      //   title: "打印组件版本检查",
      //   desc: ""
      // },
      {
        title: "验证 WSS 链接",
        desc: "该步骤完成后管理软件上已经可以正常链接云打印组件,即不会出现云打印未连接的情况",
        handle: () => this.checkWss()
      },
      {
        title: "验证 CDN 网络",
        desc: "验证模板的图片是否可以访问",
        handle: () => this.checkCDN()
      },
      {
        title: "缓存清理",
        desc: "清理打印组件的缓存数据",
        handle: () => this.clearCache(true)
      },
      {
        title: "云打印组件预览测试",
        desc: "通过预览测试组件功能",
        handle: () => this.preview(true)
      }, {
        title: "云打印组件打印测试",
        desc: "通过打印测试组件功能",
        handle: () => {
          this.selectPrinter = true
        }
      }
    ]
    CheckMain.handle = this.handle
  },
  data() {
    return {

      previewData: {
        "cmd": "print",
        "task": {
          "preview": true,
          "printer": "",
          "documents": [
            {
              "documentID": "10000001",
              "contents": [
                {
                  "data": {
                    "recipient": {
                      "address": {
                        "city": "杭州市",
                        "detail": "良睦路999号乐佳国际大厦2号楼小邮局",
                        "district": "余杭区",
                        "province": "浙江省",
                        "town": ""
                      },
                      "mobile": "13012345678",
                      "name": "菜鸟网络",
                      "phone": "057112345678"
                    },
                    "routingInfo": {
                      "consolidation": {
                        "name": "杭州",
                        "code": "hangzhou"
                      },
                      "origin": {
                        "name": "杭州",
                        "code": "POSTB"
                      },
                      "sortation": {
                        "name": "杭州"
                      },
                      "routeCode": "123A-456-789"
                    },
                    "sender": {
                      "address": {
                        "city": "杭州市",
                        "detail": "文一西路1001号阿里巴巴淘宝城5号小邮局",
                        "district": "余杭区",
                        "province": "浙江省",
                        "town": ""
                      },
                      "mobile": "13012345678",
                      "name": "阿里巴巴",
                      "phone": "057112345678"
                    },
                    "shippingOption": {
                      "code": "COD",
                      "services": {
                        "SVC-COD": {
                          "value": "200"
                        },
                        "TIMED-DELIVERY": {
                          "value": "SEVERAL-DAYS"
                        },
                        "PAYMENT-TYPE": {
                          "value": "ON-DELIVERY"
                        },
                        "SVC-INSURE": {
                          "value": "1000000"
                        },
                        "SVC-PROMISE-DELIVERY": {
                          "promise-type": "SAMEDAY_DELIVERY"
                        }
                      },
                      "title": "代收货款"
                    },
                    "waybillCode": "0123456789"
                  },
                  "templateURL": "http://cloudprint.cainiao.com/template/standard/101"
                }
              ]
            }
          ]
        }
      },
      stepDesc: [],
      active: 1,
      websock: null,
      processStatus: "process",
      appAlready: false,
      checkedWss: false,
      loadingInstance: null,
      tryOpenApp: true,
      printers: [],
      selectPrinter: false,
      selectedPrinter: ""
    }
  }
}
</script>

<style scoped>

</style>